import { shuffle } from 'lodash';

export interface BrandConfig {
  slug: string;
  url: string;
  image: string;
}

export const brands: BrandConfig[] = [
  {
    slug: 'korg',
    url: 'https://reverb.com/brand/korg',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/Korg_brands_600x300px_.png',
  },
  {
    slug: 'digitech',
    url: 'https://reverb.com/brand/digitech',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/DigiTech_brands_600x300px_.png',
  },
  {
    slug: 'fender--164',
    url: 'https://reverb.com/b/fender--164',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Fender_brands_600x300px_.png',
  },
  {
    slug: 'strymon',
    url: 'https://reverb.com/brand/strymon',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986117/Logged%20Out%20Homepage/Brand%20Logo/Strymon_brands_600x300px_.png',
  },
  {
    slug: 'squier--426',
    url: 'https://reverb.com/b/squier--426',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986117/Logged%20Out%20Homepage/Brand%20Logo/Squier_brands_600x300px_.png',
  },
  {
    slug: 'shure',
    url: 'https://reverb.com/brand/shure',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986116/Logged%20Out%20Homepage/Brand%20Logo/Shure_brands_600x300px_.png',
  },
  {
    slug: 'marshall',
    url: 'https://reverb.com/brand/marshall',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/Marshall_brands_600x300px_.png',
  },
  {
    slug: 'gretsch--203',
    url: 'https://reverb.com/b/gretsch--203',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986114/Logged%20Out%20Homepage/Brand%20Logo/Gretsch_brands_600x300px_.png',
  },
  {
    slug: 'walrus-audio',
    url: 'https://reverb.com/brand/walrus-audio',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986118/Logged%20Out%20Homepage/Brand%20Logo/Walrus-Audio_brands_600x300px_.png',
  },
  {
    slug: 'ernie-ball',
    url: 'https://reverb.com/brand/ernie-ball',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Ernie-Ball_brands_600x300px_.png',
  },
  {
    slug: 'zildjian',
    url: 'https://reverb.com/brand/zildjian',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986118/Logged%20Out%20Homepage/Brand%20Logo/Zildjian_brands_600x300px_.png',
  },
  {
    slug: 'keeley',
    url: 'https://reverb.com/brand/keeley',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/Keeley_brands_600x300px_.png',
  },
  {
    slug: 'gibson--194',
    url: 'https://reverb.com/b/gibson--194',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986114/Logged%20Out%20Homepage/Brand%20Logo/Gibson_brands_600x300px_.png',
  },
  {
    slug: 'ibanez--234',
    url: 'https://reverb.com/b/ibanez--234',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986114/Logged%20Out%20Homepage/Brand%20Logo/Ibanez_brands_600x300px_.png',
  },
  {
    slug: 'yamaha--506',
    url: 'https://reverb.com/b/yamaha--506',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986118/Logged%20Out%20Homepage/Brand%20Logo/Yamaha_brands_600x300px_.png',
  },
  {
    slug: 'electro-harmonix',
    url: 'https://reverb.com/brand/electro-harmonix',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Electro-Harmonix_brands_600x300px_.png',
  },
  {
    slug: 'boss',
    url: 'https://reverb.com/brand/boss',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986112/Logged%20Out%20Homepage/Brand%20Logo/BOSS_brands_600x300px_.png',
  },
  {
    slug: 'epiphone--169',
    url: 'https://reverb.com/b/epiphone--169',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Epiphone_brands_600x300px_.png',
  },
  {
    slug: 'pr--365',
    url: 'https://reverb.com/b/prs--365',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986116/Logged%20Out%20Homepage/Brand%20Logo/PRS_brands_600x300px_.png',
  },
  {
    slug: 'mxr',
    url: 'https://reverb.com/brand/mxr',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/MXR_brands_600x300px_.png',
  },
  {
    slug: 'roland',
    url: 'https://reverb.com/brand/roland',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986116/Logged%20Out%20Homepage/Brand%20Logo/Roland_brands_600x300px_.png',
  },
  {
    slug: 'behringer',
    url: 'https://reverb.com/brand/behringer',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Behringer_brands_600x300px_.png',
  },
  {
    slug: 'seymour-duncan',
    url: 'https://reverb.com/brand/seymour-duncan',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986116/Logged%20Out%20Homepage/Brand%20Logo/Seymour-Duncan_brands_600x300px_.png',
  },
  {
    slug: 'tc-electronic',
    url: 'https://reverb.com/brand/tc-electronic',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986117/Logged%20Out%20Homepage/Brand%20Logo/TC-Electronic_brands_600x300px_.png',
  },
  {
    slug: 'universal-audio',
    url: 'https://reverb.com/brand/universal-audio',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986117/Logged%20Out%20Homepage/Brand%20Logo/Universal-Audio_brands_600x300px_.png',
  },
  {
    slug: 'earthquaker-devices',
    url: 'https://reverb.com/brand/earthquaker-devices',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986113/Logged%20Out%20Homepage/Brand%20Logo/Earthquaker-Devices_brands_600x300px_.png',
  },
  {
    slug: 'martin--306',
    url: 'https://reverb.com/b/martin--306',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/Martin_brands_600x300px_.png',
  },
  {
    slug: 'line-6',
    url: 'https://reverb.com/brand/line-6',
    image: 'https://res.cloudinary.com/reverb-marketing/image/upload/v1708986115/Logged%20Out%20Homepage/Brand%20Logo/Line-6_brands_600x300px_.png',
  },
];

export const brandSampling = (count = brands.length) => {
  return shuffle(brands).splice(0, count);
};
